import React from 'react';
import PropTypes from 'prop-types';
import OrderConfirmModal from '../../ConfirmationModal';

function CancelOrderConfirmationModal({ show, onCancel, onConfirm }) {
  return (
    <OrderConfirmModal
      show={show}
      title="Confirm Cancel"
      onCancel={onCancel}
      onConfirm={onConfirm}
    >
      <p>Are you sure you want to cancel this changes?</p>
    </OrderConfirmModal>
  );
}

CancelOrderConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

export default CancelOrderConfirmationModal;
